import { PDFDesignLayers } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'PDF Design Layer'
const page = PDFDesignLayers

export const ViewPDFDesignLayer = Simple({
  id: '66EFB37A-EE09-4263-B271-9E84BA8F34EC',
  action: 'View',
  object,
  page,
})

export const EditPDFDesignLayer = Simple({
  id: '31372572-0BD8-46A8-A364-F507F0D681B2',
  action: 'Edit',
  object,
  page,
})

export type PDFDesignLayerPermission =
  | typeof ViewPDFDesignLayer
  | typeof EditPDFDesignLayer
